import { Component, OnInit,Input } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { EmployeeInsurance } from '../../shared/models/EmployeeInsurance.model';
import { EmployeeService } from '../../shared/service/employee.service';
import { EmployeeInsuranceInfo } from '../../shared/models/employeeinsuranceinfo';
import { isNullOrUndefined } from 'util';
import { ToastrService } from 'ngx-toastr';
import { SumAssuredListPopupComponent } from 'src/app/shared/components/sum-assured-list-popup/sum-assured-list-popup.component';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { InsurancePremiumDetails } from '../../shared/models/InsurancePremiumDetails';
import { UserService } from 'src/app/shared/service/user.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { DatePipe } from '@angular/common';
import { AppConfig } from '../../app.config';
const moment = _moment;
export const MY_FORMATS = {

  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-set-insurance-options',
  templateUrl: './set-insurance-options.component.html',
  styleUrls: ['./set-insurance-options.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SetInsuranceOptionsComponent implements OnInit {
  @Input() LoginEmpCode: any;
  empList: EmployeeInsurance[];
  premiumYearList: any;
  sumAssuredList: any;
  premiumYearId: any;
  dataSourceFTE: MatTableDataSource<EmployeeInsurance>;
  employeeInsuranceInfos: EmployeeInsuranceInfo[];
  insurancePremiumDtls: InsurancePremiumDetails;
  result: any;
  error: any;
  isShow: boolean = false;
  datePipe: DatePipe;
    disableCompanyContribution: boolean=false;
  constructor(private userService: UserService, private empSvc: EmployeeService, private config: AppConfig,  public dialog: MatDialog, public toastr: ToastrService, private dateAdapter: DateAdapter<Date>) {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.insurancePremiumDtls = new InsurancePremiumDetails();
    this.datePipe = new DatePipe('en-US');
  }
  ngOnInit() {
    this.getPremiumYearList();
  }
  ResetData() {
    this.insurancePremiumDtls = new InsurancePremiumDetails();
    this.disableCompanyContribution = false;
    this.getPremiumYearList();

  }
  rowClick(val) {
    this.insurancePremiumDtls = val;
    this.insurancePremiumDtls.IsActive = this.insurancePremiumDtls.Active == "Yes" ? true : false; 
    this.disableCompanyContribution = true;

  }
  getPremiumYearList() {
    this.empSvc.GetInsurancePermium().subscribe((data: any) => {

      this.premiumYearList = data;
    });
  }
  deleteInsurancePremium(val) {
    //console.log(val);
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      //console.log(dialogResult);
      if (dialogResult) {
        this.empSvc.DeleteInsurancePremium(val).subscribe(data => {
          this.toastr.success("Deleted successfully");
          this.getPremiumYearList();
          this.ResetData();
        },
          error => this.error = error
        );
      }
    }, error => { this.result = error; });

  }

  SaveInsurancePremiumDetails() {
    this.insurancePremiumDtls.ModifiedBy = this.LoginEmpCode;
    if (isNullOrUndefined(this.insurancePremiumDtls.PremiumYear) || isNullOrUndefined(this.insurancePremiumDtls.FromDate) || isNullOrUndefined(this.insurancePremiumDtls.ToDate) || isNullOrUndefined(this.insurancePremiumDtls.IsActive) || isNullOrUndefined(this.insurancePremiumDtls.CompanyContribution)) {
      this.toastr.warning("Please fill all the fields");
      return;
    }
    if (!isNullOrUndefined(this.insurancePremiumDtls.FromDate)) {
      this.insurancePremiumDtls.FromDate = new Date(this.datePipe.transform(this.insurancePremiumDtls.FromDate, this.config.dateFormat()));
    }
    if (!isNullOrUndefined(this.insurancePremiumDtls.ToDate)) {
      this.insurancePremiumDtls.ToDate = new Date(this.datePipe.transform(this.insurancePremiumDtls.ToDate, this.config.dateFormat()));
    }
    var oneTrue = (this.premiumYearList.filter(x => x.IsActive == true)).length;
    if (this.disableCompanyContribution == true) {
      if (oneTrue < 1) {
        this.toastr.warning("Atleast one record should be Active.");
        this.ResetData();
        return;
      }
    }
    
    this.disableCompanyContribution = false;
    this.empSvc.SaveInsurancePremiumDetails(this.insurancePremiumDtls).subscribe((data: any) => {
        if (data.ErrorType == "Exception") {
          this.toastr.warning(data.ErrorMsg);
        }
        else {
          this.getPremiumYearList();
          this.toastr.success("Saved Successfully");
          this.ResetData();
          
        }
      }, error => this.toastr.warning(error));
    }

  }
